import styled from "styled-components";

export const PageWrapper = styled.div`
  display: flex;
  position: relative;
  /* Navbar is a MUI AppBar, which defaults to position: fixed — it's out of
     normal flow, so this needs an explicit top offset (not just a shorter
     height) to actually sit below it instead of running underneath it.
     Bottom is shortened by the Footer's fixed 9vh strip for the same reason:
     Footer is position: fixed and would otherwise overlap this container. */
  margin-top: 4rem;
  height: calc(100vh - 4rem - 9vh);
  overflow: hidden;
`;

export const Sidebar = styled.aside<{ $collapsed?: boolean }>`
  width: ${({ $collapsed }) => ($collapsed ? "0" : "320px")};
  min-width: ${({ $collapsed }) => ($collapsed ? "0" : "320px")};
  background: #fff;
  border-right: ${({ $collapsed }) =>
    $collapsed ? "none" : "1px solid #e5e7eb"};
  overflow: hidden;
  z-index: 1000;
  transition: width 0.2s ease, min-width 0.2s ease;
`;

/* Fixed-width inner scroll area so the sidebar's contents don't reflow while
   the outer <Sidebar> animates its width down to 0 — they just get clipped. */
export const SidebarInner = styled.div`
  width: 320px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const SidebarToggle = styled.button<{ $collapsed?: boolean }>`
  position: absolute;
  top: 50%;
  left: ${({ $collapsed }) => ($collapsed ? "0" : "320px")};
  transform: translate(-50%, -50%);
  z-index: 1001;
  width: 24px;
  height: 48px;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #374151;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  transition: left 0.2s ease;

  &:hover {
    background: #f3f4f6;
  }
`;

export const SidebarHeader = styled.div`
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  font-family: "Work Sans", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #080d1a;
`;

export const SidebarSection = styled.div`
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
`;

export const SectionTitle = styled.p`
  font-family: "Work Sans", sans-serif;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
  margin-bottom: 0.75rem;
`;

export const MapWrapper = styled.div`
  flex: 1;
  position: relative;
  min-width: 0;

  /* Leaflet map fills the wrapper */
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
`;

export const FilterBlock = styled.div`
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  label {
    font-family: "Work Sans", sans-serif;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    user-select: none;
  }
`;

export const FilterControls = styled.div`
  margin-top: 0.625rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FilterSelect = styled.select`
  flex: 1;
  padding: 0.375rem 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.8125rem;
  color: #374151;
  background: #fff;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #0c2856;
    box-shadow: 0 0 0 2px rgba(12, 40, 86, 0.1);
  }
`;

export const FilterInput = styled.input`
  width: 72px;
  padding: 0.375rem 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.8125rem;
  color: #374151;
  text-align: right;

  &:focus {
    outline: none;
    border-color: #0c2856;
    box-shadow: 0 0 0 2px rgba(12, 40, 86, 0.1);
  }
`;

export const FilterUnit = styled.span`
  font-size: 0.75rem;
  color: #6b7280;
  white-space: nowrap;
  min-width: 60px;
`;

export const FilterHint = styled.p`
  font-size: 0.6875rem;
  color: #9ca3af;
  line-height: 1.45;
`;

export const ApplyButton = styled.button<{ $hasPending: boolean }>`
  width: 100%;
  padding: 0.75rem 1rem;
  background: ${({ $hasPending }) => ($hasPending ? "#0C2856" : "#e5e7eb")};
  color: ${({ $hasPending }) => ($hasPending ? "#fff" : "#9ca3af")};
  border: none;
  border-radius: 8px;
  font-family: "Work Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: ${({ $hasPending }) => ($hasPending ? "pointer" : "default")};
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${({ $hasPending }) => ($hasPending ? "#0a2246" : "#e5e7eb")};
  }
`;
